import React from "react";
import {Pagination} from "react-bootstrap";

function STCPaginationNext(props){
    return(
        <Pagination.Next

            style={props.style}
            className={props.className}
            onClick={props.onClick}
        >
            {props.children}
        </Pagination.Next>
    )
}
export default STCPaginationNext;